import React from 'react';
import { ROUTES } from 'Navigation';
import { SubRoutesContainer } from 'Features/Shared';

export const ComplianceMain: React.FC = () => {
  return <SubRoutesContainer route={ROUTES.COMPLIANCE} />;
};
